import { ADDIN_SESSION_COOKIE_NAME, type CopilotDefinition } from "./types";

export const excelCopilot: CopilotDefinition = {
  copilotId: "excel",
  displayName: "Excel",
  surfaceLabel: "Microsoft Excel add-in",
  surfaces: ["excel-add-in"],
  capabilities: ["excel"],
  embedded: {
    "excel-add-in": { sessionCookieName: ADDIN_SESSION_COOKIE_NAME },
  },
  display: {
    description:
      "Create, edit, and analyze spreadsheets with AI assistance. Once Excel opens, find the add-in on the Home ribbon tab — click the Magnus button.",
    category: "productivity",
    icon: "file-spreadsheet",
    color: "bg-emerald-600",
    initial: "E",
  },
  launch: {
    kind: "protocol-handler",
    uriTemplate: "ms-excel:nft|u|{origin}/assets/office-addin/blank_rev_1.xlsx",
  },
};
